import { Droplets, Heart } from "lucide-react";
import React from "react";
import Button from "../Button";

const DevicesCard = () => {
  return (
    <div className="mx-4 bg-white border border-gray-200 rounded-lg p-4">
      <div className="flex flex-row items-center gap-2">
        <Heart className="w-4 h-4" />
        <span className="text-base font-medium">Devices</span>
      </div>

      <div className="pt-4">
        <div className="flex flex-row items-center justify-between gap-2 p-2 hover:bg-slate-100 rounded-md overflow-hidden">
          <div className="flex flex-row items-center gap-2">
            <div className="bg-[var(--icon-bg-primary)] rounded-full p-2">
              <Heart className="w-4 h-4 text-[var(--app-primary)]" />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium">Heart Rate Monitor</span>
              <span className="bg-green-600 rounded-full w-2 h-2"></span>
            </div>
          </div>

          <Button size="sm" variant="outlined" rounded="full">
            View
          </Button>
        </div>

        <div className="flex flex-row items-center justify-between gap-2 p-2 hover:bg-slate-100 rounded-md overflow-hidden">
          <div className="flex flex-row items-center gap-2">
            <div className="bg-[var(--icon-bg-primary)] rounded-full p-2">
              <Droplets className="w-4 h-4 text-[var(--app-primary)]" />
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium">Glucose Monitor</span>
              <span className="bg-green-600 rounded-full w-2 h-2"></span>
            </div>
          </div>

          <Button size="sm" variant="outlined" rounded="full">
            View
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DevicesCard;
